import React from "react";
import { render } from "react-dom";
import { AADProvider } from "psg-react-components";

import "./index.scss";
import App from "./App";

import { LicenseManager } from "@ag-grid-enterprise/core";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham-dark.css";
import CustomLoader from "./components/CustomLoader";

const root = document.getElementById("root");
if (root) {
    LicenseManager.setLicenseKey(
        "CompanyName=Accenture (Ashburn, VA),LicensedGroup=AMP,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=0,AssetReference=AG-012087,ExpiryDate=11_February_2022_[v2]_MTY0NDUzNzYwMDAwMA==16c54cc1058a96f6c35900faa0834826"
    );
    render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
        root
    );
}
